// import React, { useState, useEffect, useContext } from "react";
// import PropTypes from "prop-types";
// import { NavLink } from "react-router-dom";
// import Button from "@mui/material/Button";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import Avatar from "@mui/material/Avatar";
// import brand from "dan-api/dummy/brand";
// import dummy from "dan-api/dummy/dummyContents";
// // import logo from "dan-images/logo.svg";
// import isea from "/app/images/iseapmu.webp";
// import MainMenu from "./MainMenu";
// import MainContext from "../../Services/Context/MainContext";
// import useStyles from "./sidebar-jss";
// import Tooltip from "@mui/material/Tooltip";
// import jwtDecode from "jwt-decode";
// import { getCookies } from "../../Services/UserUtil";
// import ProgressBar from "@ramonak/react-progress-bar";
// import colorfull from "dan-api/palette/colorfull";

// function SidebarContent(props) {
//   const { classes, cx } = useStyles();
//   const [transform, setTransform] = useState(0);
//   const [getUserRole, setUserRole] = useState("");
//   const allContextDetails = useContext(MainContext);

//   useEffect(() => {
//     const cookiesToken = getCookies("ac_token");

//     const getRole = jwtDecode(cookiesToken);
//     setUserRole(getRole.role);
//   }, [getCookies]);

//   const handleScroll = (event) => {
//     const scroll = event.target.scrollTop;
//     setTransform(scroll);
//   };

//   const returnRole = (getUserRole) => {
//     switch (getUserRole) {
//       case "admin":
//         return "administrator";
//       case "user":
//         return "user";
//       case "coordinator":
//         return "ic";
//       case "super_admin":
//         return "management";
//       case "pmu_admin":
//         return "pmu";
//       case "meity_manager":
//         return "meity-management";
//       default:
//         break;
//     }
//   };

//   useEffect(() => {
//     const mainContent = document.getElementById("sidebar");
//     mainContent.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   function capitalizeFirstLetter(string) {
//     // return string.charAt(0).toUpperCase() + string.slice(1);
//     if (typeof string !== "string" || string.length === 0) {
//       return null;
//     }
//     return string.charAt(0).toUpperCase() + string.slice(1);
//   }

//   const {
//     turnDarker,
//     drawerPaper,
//     toggleDrawerOpen,
//     loadTransition,
//     leftSidebar,
//     dataMenu,
//     status,
//     anchorEl,
//     openMenuStatus,
//     closeMenuStatus,
//     changeStatus,
//     isLogin,
//   } = props;

//   const setStatus = (st) => {
//     switch (st) {
//       case "online":
//         return classes.online;
//       case "idle":
//         return classes.idle;
//       case "bussy":
//         return classes.bussy;
//       default:
//         return classes.offline;
//     }
//   };
//   const completionPercentage =
//     parseInt(allContextDetails?.completion_percentage, 10) || 0;

//   // console.log("Completion Percentage:", completionPercentage);

//   return (
//     // <div
//     //   className={cx(
//     //     classes.drawerPaperClose,
//     //     !drawerPaper ? classes.drawerInner : ""
//     //   )}
//     // >
//     // <div
//     //   className={cx(
//     //     classes.drawerPaperClose,
//     //     !drawerPaper ? classes.drawerInner : ""
//     //   )}
//     // >
//     <div
//       className={cx(
//         classes.drawerInner,
//         !drawerPaper ? classes.drawerPaperClose : ""
//       )}
//     >
//       <div className={`${classes.drawerHeader} ${classes.sideHeader}`}>
//         <NavLink
//           to="/"
//           className={cx(
//             classes.brand,
//             classes.brandBar,
//             turnDarker && classes.darker
//           )}
//         >
//           <img src={isea} alt={brand.name} />
//           {brand.name}
//         </NavLink>

//         {isLogin && (
//           <div
//             className={cx(classes.profile, classes.user)}
//             style={{
//               opacity: 1 - transform / 100,
//               // marginTop: transform * -0.3,
//             }}
//           >
//             {/* <Avatar
//               alt={dummy.user.name}
//               src={dummy.user.avatar}
//               className={cx(classes.avatar, classes.bigAvatar)}
//             /> */}
//             <img
//               // src={`http://${allContextDetails.pic}`}
//               src={
//                 allContextDetails.profile_pic
//                   ? `${allContextDetails.profile_pic}`
//                   : dummy.user.avatar
//               }
//               className={classes.sideProfile}
//             />

//             <div>
//               <Tooltip
//                 title={
//                   allContextDetails.first_name
//                     ? capitalizeFirstLetter(allContextDetails.first_name) +
//                       " " +
//                       capitalizeFirstLetter(allContextDetails.last_name)
//                     : ""
//                 }
//               >
//                 <h4>
//                   {allContextDetails.first_name
//                     ? capitalizeFirstLetter(allContextDetails.first_name) +
//                       " " +
//                       capitalizeFirstLetter(allContextDetails.last_name)
//                     : ""}
//                 </h4>
//               </Tooltip>
//               {/* <Button size="small" onClick={openMenuStatus}>
//                 <i className={cx(classes.dotStatus, setStatus(status))} />
//                 {status}
//               </Button>
//               <Menu

//                 id="status-menu"
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={closeMenuStatus}
//                 className={classes.statusMenu}
//               >
//                 <MenuItem onClick={() => changeStatus("online")}>
//                   <i className={cx(classes.dotStatus, classes.online)} />
//                   Online
//                 </MenuItem>
//                 <MenuItem onClick={() => changeStatus("idle")}>
//                   <i className={cx(classes.dotStatus, classes.idle)} />
//                   Idle
//                 </MenuItem>
//                 <MenuItem onClick={() => changeStatus("bussy")}>
//                   <i className={cx(classes.dotStatus, classes.bussy)} />
//                   Bussy
//                 </MenuItem>
//                 <MenuItem onClick={() => changeStatus("offline")}>
//                   <i className={cx(classes.dotStatus, classes.offline)} />
//                   Offline
//                 </MenuItem>
//               </Menu> */}
//             </div>
//             <div className="py-2">
//               <NavLink
//                 exact
//                 to={`/${returnRole(getUserRole)}/profiles`}
//                 // activeClassName="active"
//                 // className="nav-links"
//               >
//                 Update Your Profile
//               </NavLink>
//             </div>
//             <div className={classes.progressBarTag}>
//               <span>
//                 <ProgressBar
//                   completed={completionPercentage}
//                   maxCompleted={100}
//                   bgColor={
//                     completionPercentage === 100
//                       ? "green" // Gray color for 100%
//                       : `rgba(76, 175, 80, ${completionPercentage / 100})`
//                   }
//                   completedClassName={classes.barCompleted}
//                   labelClassName={classes.label}
//                 />
//               </span>
//               <span>
//                 {completionPercentage === 100
//                   ? "Profile completed"
//                   : `${completionPercentage}% completion`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//       <div
//         id="sidebar"
//         className={`${cx(
//           classes.menuContainer,
//           leftSidebar && classes.rounded,
//           isLogin && classes.withProfile,
//           classes.activeBG
//         )} `}
//       >
//         {/* <div className=""> */}
//         <MainMenu
//           loadTransition={loadTransition}
//           dataMenu={dataMenu}
//           toggleDrawerOpen={toggleDrawerOpen}
//         />
//         {/* </div> */}
//       </div>
//     </div>
//   );
// }

// SidebarContent.propTypes = {
//   drawerPaper: PropTypes.bool.isRequired,
//   turnDarker: PropTypes.bool,
//   toggleDrawerOpen: PropTypes.func,
//   loadTransition: PropTypes.func,
//   leftSidebar: PropTypes.bool.isRequired,
//   dataMenu: PropTypes.array.isRequired,
//   status: PropTypes.string.isRequired,
//   anchorEl: PropTypes.object,
//   openMenuStatus: PropTypes.func.isRequired,
//   closeMenuStatus: PropTypes.func.isRequired,
//   changeStatus: PropTypes.func.isRequired,
//   isLogin: PropTypes.bool,
// };

// SidebarContent.defaultProps = {
//   turnDarker: false,
//   toggleDrawerOpen: () => {},
//   loadTransition: () => {},
//   anchorEl: null,
//   isLogin: true,
// };

// export default SidebarContent;

import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import brand from "dan-api/dummy/brand";
import dummy from "dan-api/dummy/dummyContents";
// import logo from "dan-images/logo.svg";
import isea from "/app/images/iseapmu.webp";
import MainMenu from "./MainMenu";
import MainContext from "../../Services/Context/MainContext";
import useStyles from "./sidebar-jss";
import Tooltip from "@mui/material/Tooltip";
import jwtDecode from "jwt-decode";
import { getCookies } from "../../Services/UserUtil";
import ProgressBar from "@ramonak/react-progress-bar";
import colorfull from "dan-api/palette/colorfull";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { getCookieStorage } from "../../Services/conferenceUtils";

function SidebarContent(props) {
  const { classes, cx } = useStyles();
  const [transform, setTransform] = useState(0);
  const [getUserRole, setUserRole] = useState("");
  const allContextDetails = useContext(MainContext);

  useEffect(() => {
    const cookiesToken = getCookies("ac_token");

    const getRole = jwtDecode(cookiesToken);
    setUserRole(getRole.role);
  }, [getCookies]);

  const handleScroll = (event) => {
    const scroll = event.target.scrollTop;
    setTransform(scroll);
  };

  const returnRole = (getUserRole) => {
    switch (getUserRole) {
      case "admin":
        return "administrator";
      case "user":
        return "user";
      case "coordinator":
        return "ic";
      case "super_admin":
        return "management";
      case "pmu_admin":
        return "pmu";
      case "meity_manager":
        return "meity-management";
      default:
        break;
    }
  };
  // let getimageToken = getCookieStorage("base_64");
  let getimageToken = process.env.SHOW_PROFILE_KEY;

  useEffect(() => {
    const mainContent = document.getElementById("sidebar");
    mainContent.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  function capitalizeFirstLetter(string) {
    // return string.charAt(0).toUpperCase() + string.slice(1);
    if (typeof string !== "string" || string.length === 0) {
      return null;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const {
    turnDarker,
    drawerPaper,
    toggleDrawerOpen,
    loadTransition,
    leftSidebar,
    dataMenu,
    status,
    anchorEl,
    openMenuStatus,
    closeMenuStatus,
    changeStatus,
    isLogin,
  } = props;

  const setStatus = (st) => {
    switch (st) {
      case "online":
        return classes.online;
      case "idle":
        return classes.idle;
      case "bussy":
        return classes.bussy;
      default:
        return classes.offline;
    }
  };
  const completionPercentage =
    parseInt(allContextDetails?.completion_percentage, 10) || 0;

  // console.log("Completion Percentage:", completionPercentage);

  return (
    // <div
    //   className={cx(
    //     classes.drawerPaperClose,
    //     !drawerPaper ? classes.drawerInner : ""
    //   )}
    // >
    // <div
    //   className={cx(
    //     classes.drawerPaperClose,
    //     !drawerPaper ? classes.drawerInner : ""
    //   )}
    // >
    <div
      className={cx(
        classes.drawerInner,
        !drawerPaper ? classes.drawerPaperClose : ""
      )}
    >
      <div className={`${classes.drawerHeader} ${classes.sideHeader}`}>
        <NavLink
          to="/"
          className={cx(
            classes.brand,
            classes.brandBar,
            turnDarker && classes.darker
          )}
        >
          <img src={isea} alt={brand.name} />
          {brand.name}
        </NavLink>

        {isLogin && (
          <div
            className={cx(classes.profile, classes.user)}
            style={{
              opacity: 1 - transform / 100,
              // marginTop: transform * -0.3,
            }}
          >
            {/* <Avatar
              alt={dummy.user.name}
              src={dummy.user.avatar}
              className={cx(classes.avatar, classes.bigAvatar)}
            /> */}
            <img
              // src={`http://${allContextDetails.pic}`}
              src={
                allContextDetails.profile_pic
                  ? // ? `${allContextDetails.profile_pic}`
                    `${allContextDetails.profile_pic}?blob=${getimageToken}`
                  : dummy.user.avatar
              }
              className={classes.sideProfile}
            />

            <div className={classes.sideProfileName}>
              <Tooltip
                title={
                  allContextDetails.first_name
                    ? capitalizeFirstLetter(allContextDetails.first_name) +
                      " " +
                      capitalizeFirstLetter(allContextDetails.last_name)
                    : ""
                }
              >
                <h4>
                  {allContextDetails.first_name
                    ? capitalizeFirstLetter(allContextDetails.first_name) +
                      " " +
                      capitalizeFirstLetter(allContextDetails.last_name)
                    : ""}
                </h4>
              </Tooltip>
              {/* <Button size="small" onClick={openMenuStatus}>
                <i className={cx(classes.dotStatus, setStatus(status))} />
                {status}
              </Button>
              <Menu

                id="status-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeMenuStatus}
                className={classes.statusMenu}
              >
                <MenuItem onClick={() => changeStatus("online")}>
                  <i className={cx(classes.dotStatus, classes.online)} />
                  Online
                </MenuItem>
                <MenuItem onClick={() => changeStatus("idle")}>
                  <i className={cx(classes.dotStatus, classes.idle)} />
                  Idle
                </MenuItem>
                <MenuItem onClick={() => changeStatus("bussy")}>
                  <i className={cx(classes.dotStatus, classes.bussy)} />
                  Bussy
                </MenuItem>
                <MenuItem onClick={() => changeStatus("offline")}>
                  <i className={cx(classes.dotStatus, classes.offline)} />
                  Offline
                </MenuItem>
              </Menu> */}
            </div>
            <div className={`py-2 ${classes.sideProfileUpdateMsg}`}>
              <NavLink
                exact
                to={`/${returnRole(getUserRole)}/profiles`}
                // activeClassName="active"
                // className="nav-links"
              >
                Update Your Profile
              </NavLink>
            </div>
            <EditOutlinedIcon className={classes.sideProfileEditIcon} />
            <div className={classes.progressBarTag}>
              <span>
                <ProgressBar
                  completed={completionPercentage}
                  maxCompleted={100}
                  bgColor={
                    completionPercentage === 100
                      ? "green" // Gray color for 100%
                      : `rgba(76, 175, 80, ${completionPercentage / 100})`
                  }
                  completedClassName={classes.barCompleted}
                  labelClassName={classes.label}
                />
              </span>
              <span>
                {completionPercentage === 100
                  ? "Profile completed"
                  : `${completionPercentage}% completion`}
              </span>
            </div>
          </div>
        )}
      </div>
      <div
        id="sidebar"
        className={`${cx(
          classes.menuContainer,
          leftSidebar && classes.rounded,
          isLogin && classes.withProfile,
          classes.activeBG
        )} `}
      >
        {/* <div className=""> */}
        <MainMenu
          loadTransition={loadTransition}
          dataMenu={dataMenu}
          toggleDrawerOpen={toggleDrawerOpen}
        />
        {/* </div> */}
      </div>
    </div>
  );
}

SidebarContent.propTypes = {
  drawerPaper: PropTypes.bool.isRequired,
  turnDarker: PropTypes.bool,
  toggleDrawerOpen: PropTypes.func,
  loadTransition: PropTypes.func,
  leftSidebar: PropTypes.bool.isRequired,
  dataMenu: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  anchorEl: PropTypes.object,
  openMenuStatus: PropTypes.func.isRequired,
  closeMenuStatus: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  isLogin: PropTypes.bool,
};

SidebarContent.defaultProps = {
  turnDarker: false,
  toggleDrawerOpen: () => {},
  loadTransition: () => {},
  anchorEl: null,
  isLogin: true,
};

export default SidebarContent;
